// @flow
import React from 'react';
import { connect } from 'react-redux';
import { useTheme } from '@material-ui/styles';
import Avatar from '@material-ui/core/Avatar';

import AvatarLogo from './AvatarLogo';

interface Props {
  width?: number;
  height?: number;
  firebaseUser: Object;
  user: Object;
}

const UserIcon = ({ width, height, firebaseUser, user }: Props) => {
  const theme = useTheme();

  if (firebaseUser && user?.userPhoto?.url) {
    return (
      <Avatar
        src={user.userPhoto.url}
        alt="profile_photo"
        style={{
          width: width || 40,
          height: height || 40,
        }}
      />
    );
  }

  return (
    <div>
      <AvatarLogo
        color={
          theme.palette.type === 'light'
            ? theme.palette.ava.navyGroup.convoText
            : theme.palette.ava.navyGroup.convoTextDark
        }
        width={width || 40}
        height={height || 40}
      />
    </div>
  );
};

const mapStateToProps = ({ firebase: { user }, scribeSession: { captioner } }) => ({
  firebaseUser: user,
  user: captioner,
});

export default connect(mapStateToProps)(UserIcon);
